import React from "react";
import { TitleThickThin } from "@components/titles";
import styled from "@emotion/styled";
import SliderCollectionAgents from "@components/slider-collection-agents";
import Link from "next/link";
import { CPagesPath } from "shared/models/const/pages-path";
import Button from "@components/Button";
import { useTranslations } from "next-intl";
import { Grid, Typography } from "@mui/material";
import WsSectionTitleWithThinTitle from "@components/a1-refactor/typography/WsSectionTitleWithThinTitle copy";
function AgentsCollections() {
  const translation = useTranslations("collection.certifiedAgents");

  const agentTitle = translation("title") || "";

  const [titleOne, titleTwo, ...rest] = agentTitle.split(" ");

  return (
    <ContentAgentsCollector>
      {/* <TitleThickThin
        thinTitle={rest.join(" ")}
        thickTitle={}
        color="--color-brand-blue-collection-main"
      ></TitleThickThin> */}
      <Grid container justifyContent={"center"} mt={4} mb={5}>
        <WsSectionTitleWithThinTitle
          title={rest.join(" ")}
          subtitle={`${titleOne} ${titleTwo}`}
          color="--color-brand-blue-collection-main"
        />
      </Grid>
      <SliderCollectionAgents></SliderCollectionAgents>
      <CollectionButton>
        <Link href={CPagesPath.es.collection_agents_list} passHref>
          <Button component="a" bg="--color-brand-red-tertiary">
            {translation("seeMore")}
          </Button>
        </Link>
      </CollectionButton>
    </ContentAgentsCollector>
  );
}

export default AgentsCollections;

const CollectionButton = styled.article`
  width: 100%;
  margin: auto;
  margin-top: 50px;
  display: flex;
  justify-content: center;
`;

const ContentAgentsCollector = styled.div`
  min-height: 75vh;
  background: var(--color-brand-cream-primary);
  padding: 70px 0px;
`;
